<template>
  <div id="archive">
    <AppNavSub :routes="archiveRoutes"/>
    <!-- TODO use keep-alive to cache components -->
    <router-view />
  </div>
</template>
<script>
import configRoutes from '../router/configRoutes';
import AppNavSub from "@/components/header/AppNavSub.vue";
export default {
  name: 'Archive',
  components: {
    AppNavSub,
  },
  data: () => ({
    archiveRoutes: configRoutes.appNavSubRoutes.archive
  }),
};
</script>
